export const environment = {
  production: true,
  apiURL: 'https://api.wattzhub.com/',
  STRIPE_KEY: 'pk_live_51Ifl3VJlhKvePRYAZj0uqkK2iyCmmUCq5TrN5BBYsdySy09qzwRd7jmr3AZ31Sqv5suq1nTaY4RZPbixfQYs0piu00eTiDmRzb'
};

